class CartGWP {
  /**
   *  Update the cart if the free gift eligibility has changed.
   *
   * @param {ActiveGWP} gwp
   * @param {Cart} cart
   */
  static async updateCartIfNeeded(gwp, cart) {
    const status = this.getStatus(gwp, cart);
    const variantId = Number(gwp.variant.id.split('/').pop());

    /** @type {LineItem|null} */
    let fgItem = null;

    for (const item of cart.items) {
      if (item.properties._freegift) {
        fgItem = item;
        break;
      }

      // Special case if use adds the same product as the free gift and it gets converteed
      // automatically.
      if (item.variant_id === variantId && item.final_price === 0) {
        fgItem = item;
      }
    }

    /** @type {'noop'|'add'|'remove'|'set-property'} */
    let action = 'noop';

    if (fgItem && fgItem.final_price > 0) {
      action = 'remove';
    } else if (
      fgItem &&
      fgItem.final_price === 0 &&
      !fgItem.properties._freegift
    ) {
      action = 'set-property';
    } else if (
      !fgItem &&
      status.isEligible &&
      status.percentage >= 100 &&
      status.explicitlyDeleted === false
    ) {
      action = 'add';
    }
    this.#log('%c[FG] Action', action);

    /** @type {CartItems} */
    // @ts-expect-error
    const cartItems = document.querySelector('cart-items');

    /** @type {CartDrawer} */
    // @ts-expect-error
    const cartDrawer = document.querySelector('cart-drawer');

    switch (action) {
      case 'noop':
        this.#log('Noop');
        break;

      case 'add':
        this.#log('Adding fg');
        await cartItems.addFreeGift(gwp.variant.id, gwp.discount.id);
        break;

      case 'remove':
        this.#log('Removing fg');
        /** @ts-expect-error */
        await cartItems.removeFreeGift(fgItem.key);
        break;
      case 'set-property':
        this.#log('Setting fg property');
        await cartItems.addLineItemProperty(
          /** @ts-expect-error */
          fgItem.key,
          '_freegift',
          gwp.discount.id,
          false,
        );
        cartDrawer.showConfetti();
        break;
    }
  }

  static async explicitRemoveFreeGift() {
    /** @type {CartDrawer} */
    // @ts-expect-error
    const cartDrawer = document.querySelector('cart-drawer');

    /** @type {CartItems} */
    // @ts-expect-error
    const cartItems = document.querySelector('cart-items');
    const { gwp, cart } = cartDrawer.getFreeGiftStatusAndCart();

    if (gwp == null) {
      return;
    }

    /** @type {LineItem|null} */
    let fgItem = null;

    for (const item of cart.items) {
      if (item.properties._freegift) {
        fgItem = item;
        break;
      }
    }

    if (fgItem) {
      try {
        cartItems.enableLoading(true);

        await this.#setCartAttribute(
          '_gwp_explicitly_removed',
          gwp.discount.id,
        );
        await cartItems.removeFreeGift(fgItem.key);

        // Bit hacky, but good enough for now.
        const progressUI = document.querySelector('cart-gwp-progress-bar');

        if (progressUI) {
          progressUI.style.display = 'none';
        }
      } catch (e) {
        console.error('[FG] Error removing free gift from cart', e);
      } finally {
        cartItems.disableLoading(true);
      }
    }
  }

  static isExplicitlyRemoved() {
    /** @type {CartDrawer} */
    // @ts-expect-error
    const cartDrawer = document.querySelector('cart-drawer');
    const { gwp, cart } = cartDrawer.getFreeGiftStatusAndCart();

    if (gwp == null) {
      return false;
    }

    return cart.attributes._gwp_explicitly_removed === gwp.discount.id;
  }

  /**
   * @param {ActiveGWP} gwp
   * @param {Cart} cart
   */
  static getStatus(gwp, cart) {
    const thresholdLocal = gwp.discount.threshold;
    const cartTotal = cart.items.reduce((total, item) => {
      if (gwp.discount.isOneTimePurchase && !item.selling_plan_allocation) {
        return total + item.final_line_price;
      }

      if (gwp.discount.isSubscription && item.selling_plan_allocation) {
        return total + item.final_line_price;
      }
      return total;
    }, 0);

    const remaining = thresholdLocal - cartTotal;
    let percentage = Math.min(100, (cartTotal / thresholdLocal) * 100);

    // We do this so it's clearer some progress left is needed
    if (percentage > 98 && percentage < 100) {
      percentage = 98;
    }

    const storedDiscountId = cart.attributes._gwp_explicitly_removed || null;
    const explicitlyDeleted = storedDiscountId === `${gwp.discount.id}`;

    this.#log('[FG] Threshold Local', thresholdLocal);
    this.#log('[FG] Cart Total', cartTotal);
    this.#log('[FG] Remaining', remaining);
    this.#log('[FG] Percentage', percentage);

    return {
      thresholdLocal,
      remaining,
      percentage,
      explicitlyDeleted,
      isEligible: percentage >= 100,
    };
  }

  /**
   * @param {any} args
   */
  static #log(...args) {
    // console.log('%c[FG]', 'color:yellow;font-weight:bold;', ...args);
  }

  /**
   * @param {string} key
   * @param {string} value
   */
  static async #setCartAttribute(key, value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [key]: value,
        },
      }),
    });
  }
}
